import React, { useState } from 'react'
import HaldorLogo from "../../assets/haldor_logo_white.svg";
import auth from "../../lib/auth";
import { Link } from 'react-router-dom';

const Header = () => {


  return (
    <div className='header'>
            
            <div className='title'>
              <img src={HaldorLogo} className='img-header'></img>
              
            </div>
            
            <div className='login-tag'>
              <Link onClick={() => auth.logout()} href='/login'>Logga ut</Link>
              
            </div>
            
    </div>
    
  )
}

export default Header